import { createFilterOptions } from '@mui/material/Autocomplete';

// Case-insensitive "starts with" matching (MUI's Autocomplete default is
// substring match, not prefix match).
const PREFIX_MATCH_CONFIG = { matchFrom: 'start', trim: true };

// For Autocompletes whose options are plain strings.
export const prefixFilterOptions = createFilterOptions(PREFIX_MATCH_CONFIG);

// For Autocompletes whose options are objects — pass the same getOptionLabel
// already used for rendering: filterOptions={createPrefixFilter(getOptionLabel)}
export function createPrefixFilter(getOptionLabel) {
  return createFilterOptions({ ...PREFIX_MATCH_CONFIG, stringify: getOptionLabel });
}
